export const GET_GIFT_CODES_LIST_START = 'GET_GIFT_CODES_LIST_START';
export const GET_GIFT_CODES_LIST_SUCCESS = 'GET_GIFT_CODES_LIST_SUCCESS';
export const GET_GIFT_CODES_LIST_FAILED = 'GET_GIFT_CODES_LIST_FAILED';

export const GET_SINGLE_GIFT_CODE_START = 'GET_SINGLE_GIFT_CODE_START';
export const GET_SINGLE_GIFT_CODE_SUCCESS = 'GET_SINGLE_GIFT_CODE_SUCCESS';
export const GET_SINGLE_GIFT_CODE_FAILED = 'GET_SINGLE_GIFT_CODE_FAILED';

export const GET_GIFT_CARD_HISTORY_START = 'GET_GIFT_CARD_HISTORY_START';
export const GET_GIFT_CARD_HISTORY_SUCCESS = 'GET_GIFT_CARD_HISTORY_SUCCESS';
export const GET_GIFT_CARD_HISTORY_FAILED = 'GET_GIFT_CARD_HISTORY_FAILED';

export const GET_GIFT_CARD_TEMPLATES_START = 'GET_GIFT_CARD_TEMPLATES_START';
export const GET_GIFT_CARD_TEMPLATES_SUCCESS = 'GET_GIFT_CARD_TEMPLATES_SUCCESS';
export const GET_GIFT_CARD_TEMPLATES_FAILED = 'GET_GIFT_CARD_TEMPLATES_FAILED';

export const CREATE_GIFT_CARD_CODE_START = 'CREATE_GIFT_CARD_CODE_START';
export const CREATE_GIFT_CARD_CODE_SUCCESS = 'CREATE_GIFT_CARD_CODE_SUCCESS';
export const CREATE_GIFT_CARD_CODE_FAILED = 'CREATE_GIFT_CARD_CODE_FAILED';


export const getGiftCodesListStart = (isCSVData) => ({
  type: GET_GIFT_CODES_LIST_START,
  isCSVData
});

export const getGiftCodesListSuccess = (data, isCSVData) => ({
  type: GET_GIFT_CODES_LIST_SUCCESS,
  data,
  isCSVData
});

export const getGiftCodesListFailed = (error, isCSVData) => ({
  type: GET_GIFT_CODES_LIST_FAILED,
  error,
  isCSVData
});

export const getSingleGiftCodeStart = () => ({
  type: GET_SINGLE_GIFT_CODE_START
});

export const getSingleGiftCodeSuccess = (data) => ({
  type: GET_SINGLE_GIFT_CODE_SUCCESS,
  data
});

export const getSingleGiftCodeFailed = (error) => ({
  type: GET_SINGLE_GIFT_CODE_FAILED,
  error
});

export const getGiftCardHistoryStart = () => ({
  type: GET_GIFT_CARD_HISTORY_START
});

export const getGiftCardHistorySuccess = (data) => ({
  type: GET_GIFT_CARD_HISTORY_SUCCESS,
  data
});

export const getGiftCardHistoryFailed = (error) => ({
  type: GET_GIFT_CARD_HISTORY_FAILED,
  error
});

export const getGiftCardTemplatesStart = () => ({
  type: GET_GIFT_CARD_TEMPLATES_START
});

export const getGiftCardTemplatesSuccess = (data) => ({
  type: GET_GIFT_CARD_TEMPLATES_SUCCESS,
  data
});

export const getGiftCardTemplatesFailed = (error) => ({
  type: GET_GIFT_CARD_TEMPLATES_FAILED,
  error
});

export const createGiftCardCodeStart = () => ({
  type: CREATE_GIFT_CARD_CODE_START
});

export const createGiftCardCodeSuccess = (data) => ({
  type: CREATE_GIFT_CARD_CODE_SUCCESS,
  data
});

export const createGiftCardCodeFailed = (error) => ({
  type: CREATE_GIFT_CARD_CODE_FAILED,
  error
});
